import type { FC } from "react";

import HighlightTerm from "app/components/highlight-term/HighlightTerm";
import type { ITopic } from "pro-features/pages/module start page/src/keyword analysis/topics/types";

import {
    TopicName,
    AutocompleteTopicsListItemWrapper,
    ContentContainer,
    Breadcrumbs,
    HighlightedText,
} from "./StyledComponents";
import { transformPath } from "./utils";

interface IAutocompleteTopicsListItem {
    topic: ITopic;
    isActive: boolean;
    onClick: (topicId: ITopic) => void;
    query?: string;
}

const AutocompleteTopicsListItem: FC<IAutocompleteTopicsListItem> = ({ topic, query, isActive, onClick }) => {
    const { Name, Path } = topic;
    return (
        <AutocompleteTopicsListItemWrapper
            data-automation="AutocompleteTopicsListItem"
            isActive={isActive}
            onClick={() => onClick(topic)}
        >
            <ContentContainer>
                <Breadcrumbs>{transformPath(Path)}</Breadcrumbs>
                <TopicName>
                    <HighlightTerm
                        sentence={Name}
                        highlightTerm={query}
                        HighlightComponent={HighlightedText}
                    />
                </TopicName>
            </ContentContainer>
        </AutocompleteTopicsListItemWrapper>
    );
};

export default AutocompleteTopicsListItem;
